import { createEntityAdapter } from '@reduxjs/toolkit';
import { NftSaleDetails } from 'src/features/common/collectible/collectible.typing';

export const NftSalesAdapter = createEntityAdapter<NftSaleDetails>({
    selectId: (item) => item.nftId,
});
